import { render, staticRenderFns } from "./TeacherStatistics.vue?vue&type=template&id=4aef594e&scoped=true&"
import script from "./TeacherStatistics.vue?vue&type=script&lang=js&"
export * from "./TeacherStatistics.vue?vue&type=script&lang=js&"
import style0 from "./TeacherStatistics.vue?vue&type=style&index=0&id=4aef594e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aef594e",
  null
  
)

export default component.exports